import CircleColor from "pages/Flixx/CircleColor"
import { Div } from "ui"
import { Text } from "ui/index"
import useResponsive from "utils/hooks/useResponsive"

import Icon from "./Icon"

const Item = ({
  icon,
  img: Img,
  title,
  description: Descrip
}) => {

  const { isTab } = useResponsive()

  const currentDescription = typeof Descrip === 'function'
    ? <Descrip />
    : Descrip

  return (
    <Div
      display='flex'
      flexDirection={isTab ? 'column' : 'row'}
      justifyContent='space-between'
      alignItems={isTab ? 'center' : 'unset'}
      gap={32}
      width='90%'
      maxWidth={1000}
      margin='0 auto'
    >
      <Div
        width='90%'
        maxWidth={368}
        marginTop={67}
        display='flex'
        flexDirection='column'
        alignItems={isTab ? 'center' : 'unset'}
      >
        <Icon icon={icon} />
        <Div marginTop={32} marginBottom={16}>
          <Text
            size='xl'
            color='headline'
            align={isTab ? 'center' : 'left'}
          >
            {title}
          </Text>
        </Div>
        <Text align={isTab ? 'center' : 'left'}>
          {currentDescription}
        </Text>
      </Div>

      <Div width={isTab ? '100%' : '50%'} maxWidth={464} position='relative' display='grid' placeItems='center'>
        <CircleColor
          width={400}
          height={400}
          opacity={.32}
          left='50%'
          transform='translateX(-50%)'
        />
        <Div height='100%' width='100%'>
          {Img && <Img height='100%' width='100%' />}
        </Div>
      </Div>
    </Div>
  )
}

export default Item